import { render, staticRenderFns } from "./IconsGallery.vue?vue&type=template&id=38e86350&scoped=true"
import script from "./IconsGallery.vue?vue&type=script&lang=js"
export * from "./IconsGallery.vue?vue&type=script&lang=js"
import style0 from "./IconsGallery.vue?vue&type=style&index=0&id=38e86350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e86350",
  null
  
)

export default component.exports